import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import { axiosInstance } from '@applyboard/ui-utils';
import { compose, lifecycle, withPropsOnChange, withState } from 'recompose';
import { connect } from 'react-redux';
import NotesListing from "./NotesListing";
import notesListingEnhancer from "../../../enhancers/notesListingEnhancer";
import { notesReceivedAction } from "../../../store/actions/application";
import { applicationIdSelector } from '@applyboard/ab-common';
import displayLoadingState from "../../LoadingPage/displayLoadingState";
import { API_APPLICATION_PREFIX } from "../../../constants/consts";
var getApplicationNotesRequest = function getApplicationNotesRequest(applicationId) {
  return axiosInstance.get("".concat(API_APPLICATION_PREFIX, "/").concat(applicationId, "/notes"));
};
var enhancer = compose(notesListingEnhancer, withState('loading', 'setLoading', false), connect(function (store) {
  return {
    applicationId: applicationIdSelector(store)
  };
}, function (dispatch) {
  return {
    retrieveNotesList: function retrieveNotesList(applicationId) {
      if (!applicationId) return Promise.reject({
        message: 'invalid application id to retrieve notes from. '
      });
      return getApplicationNotesRequest(applicationId).then(function (data) {
        return dispatch(notesReceivedAction(data.data));
      });
    }
  };
}),
// eslint-disable-next-line @typescript-eslint/no-explicit-any
lifecycle({
  componentDidMount: function componentDidMount() {
    var _this$props = this.props,
      applicationId = _this$props.applicationId,
      notes = _this$props.notes,
      private_notes = _this$props.private_notes,
      retrieveNotesList = _this$props.retrieveNotesList,
      setLoading = _this$props.setLoading;
    if (notes.length <= 0 && private_notes.length <= 0) {
      setLoading(true);
      retrieveNotesList(applicationId)["catch"](function () {}).then(function () {
        setLoading(false);
      });
    }
  }
}), withPropsOnChange(['publicOnly', 'privateOnly', 'public_notes', 'private_notes'], function (_ref) {
  var publicOnly = _ref.publicOnly,
    privateOnly = _ref.privateOnly,
    public_notes = _ref.public_notes,
    private_notes = _ref.private_notes;
  if (!publicOnly && !privateOnly) return {};
  if (publicOnly && privateOnly) {
    console.warn("NotesListing: You cannot have both publicOnly and privateOnly props set. As a result, I'm showing everything.");
    return {};
  }
  if (publicOnly) return {
    notes: public_notes
  };
  if (privateOnly) return {
    notes: private_notes
  };
  return {};
}), withPropsOnChange(['with_alert_only'], function (_ref2) {
  var with_alert_only = _ref2.with_alert_only,
    notes = _ref2.notes,
    privateOnly = _ref2.privateOnly;
  if (privateOnly) return {};
  if (!with_alert_only) return {};
  return {
    notes: notes
  };
}), displayLoadingState());
export default enhancer(NotesListing);